import cx from 'classnames';
import Link from 'next/link';

import VehicleCard from '../../../../ui/v2/cards/vehicle';
import useModelVersionLink from '../../../../ui/vehicle-list/use-model-version-link';

type TopModelsProps = {
  title: string;
  models: TResultAPICarsBySlug['top_models'];
  brand: string;
};

type ArrElement<ArrType> = ArrType extends readonly (infer ElementType)[]
  ? ElementType
  : never;

type TopModelCardProps = {
  model: ArrElement<TResultAPICarsBySlug['top_models']>;
  brand: string;
};

const ModelCard = ({ model, brand }: TopModelCardProps) => {
  const linkProps = useModelVersionLink({
    isPicker: false,
    have_versions: model.have_versions,
    slug: model.slug,
  });

  return (
    <Link {...linkProps}>
      <VehicleCard
        image={model.image}
        boldLine={model.name}
        lightLine={`[${model.start_date}-${
          model.end_date || new Date().getFullYear()
        }]`}
        hasHoverEffect={true}
        vehicleInfo={{
          vehicle: `${brand} ${model.name}`,
          year: `[${model.start_date}-${
            model.end_date || new Date().getFullYear()
          }]`,
        }}
      />
    </Link>
  );
};

const TopModels = ({ title, models, brand }: TopModelsProps) => {
  if (!models?.length) return null;

  return (
    <div className="container mx-auto mt-12 max-lg:pl-4">
      <span className="mb-6 mt-12 font-extrabold text-[32px] text-brand-logo leading-10">
        {title}
      </span>
      <div className="w-full overflow-x-auto lg:overflow-x-visible">
        <div
          className={cx(
            'grid grid-cols-6 gap-4',
            'w-[calc(100vw*2.4)] lg:w-auto'
          )}
        >
          {models?.length &&
            models.map((model, i) => (
              <ModelCard key={i} model={model} brand={brand} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default TopModels;
